import { InterpreterResponseDto } from '../dto/res/interpreterResponseDto';
import { InterpreterRequestDto } from '../dto/req/interpreterRequestDto';
import { SupplementAInterpreterForm } from '../../../features/supplement-a/application/validators/supplement_a.schema';

export function mapInterpreterResponseDtoToEntity(
  dto: InterpreterResponseDto
): SupplementAInterpreterForm {
  return {
    interpreterFirstName: dto.firstName,
    interpreterLastName: dto.lastName,
    interpreterMiddleInitial: dto.middleName ?? '',
    interpreterHomeAddress: dto.address,
    interpreterCity: dto.city,
    interpreterState: dto.stateId,
    interpreterSignature: dto.signature,
    interpreterZipcode: dto.zipCode,
    panelty_checkbox: true,
    interpreterSignatureDate: new Date(dto.signatureDate),
    supplementAId: dto.supplementAId,
  };
}

// Maps an array of InterpreterResponseDto to an array of SupplementAInterpreterForm
export function mapInterpreterResponseDtoArrayToEntity(
  dtos: InterpreterResponseDto[]
): SupplementAInterpreterForm[] {
  return dtos.map(mapInterpreterResponseDtoToEntity);
}

export function mapInterpreterFormToDto(
  form: Array<SupplementAInterpreterForm>,
  i9FormId: string | undefined
): InterpreterRequestDto {
  return {
    i9FormId,
    supplementA: form.map((f) => ({
      supplementAId: f.supplementAId,
      firstName: f.interpreterFirstName,
      lastName: f.interpreterLastName,
      middleName: f.interpreterMiddleInitial,
      address: f.interpreterHomeAddress,
      city: f.interpreterCity,
      stateId: f.interpreterState,
      signature: f.interpreterSignature,
      zipCode: f.interpreterZipcode,
      isSection1AssistedAttested:f.panelty_checkbox,
      signatureDate: f.interpreterSignatureDate.toISOString(),
    })),
  };
}
